const certifications = [
  {
    id: "sap-integration",
    title: "SAP Certified Associate – Integration Developer",
    issuer: "SAP",
    file: "/certifications/sap-integration.pdf",
    description:
      "This certification validates core and advanced skills in SAP Integration Suite including Cloud Integration (CPI), adapters, message mappings, APIs, security configuration, monitoring, and enterprise integration best practices."
  },
  {
    id: "java-fullstack",
    title: "Java Full Stack Development",
    issuer: "Tap Academy",
    file: null,
    description:
      "Hands-on full stack development training covering Java, Spring Boot, Hibernate, MySQL for backend and HTML, CSS, JavaScript, React.js for frontend development."
  },
  {
    id: "mern-stack",
    title: "MERN Stack Development",
    issuer: "Physics Wallah",
    file: "/certifications/physics wallah certificate.pdf",
    description:
      "Comprehensive MERN stack training covering MongoDB, Express.js, React.js, and Node.js with real-world full stack application development."
  }
];

export default certifications;
